<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p47"><span><a href="#/Contents#rp47">LEMON MUSHROOM SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Fresh and dried mushrooms combine in this delicious lemon-accented soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1½ cups hot water</span></p>
<p class="hang"><span>1 ounce dried porcini mushrooms</span></p>
<p class="hang"><span>¾ cup thinly sliced onion</span></p>
<p class="hang"><span>1½ tablespoons minced garlic</span></p>
<p class="hang"><span>2 teaspoons flour</span></p>
<p class="hang"><span>1 quart Rich Chicken Stock (see <a href="#/Chapter014#p4">p. 4</a>)</span></p>
<p class="hang"><span>¼ cup dry white wine (optional)</span></p>
<p class="hang"><span>4 ounces cremini mushrooms, quartered</span></p>
<p class="hang"><span>1 tablespoon fresh or 1 teaspoon dried rosemary leaves</span></p>
<p class="hang"><span>¼ cup each: chopped fresh lemon pulp, minced parsley, divided</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>6 Bruschetta (½ recipe) (see <span href="#/Chapter132#p850" title="Link target outside of Sample">p. 637</span>)</span></p>
<p class="normalt"><span><a id="page_36"></a><b>1.</b> Pour hot water over porcini mushrooms in bowl; let stand until softened, about 20 minutes. Remove mushrooms with slotted spoon; strain liquid through double layer of cheesecloth and reserve 2 tablespoons liquid. Inspect porcini carefully, rinsing if necessary, to remove grit. Chop coarsely.</span></p>
<p class="normala"><span><b>2.</b> Sauté onion and garlic in lightly greased large saucepan until tender, about 5 minutes. Sprinkle with flour and cook 1 minute. Add stock, wine, porcini and cremini mushrooms, reserved porcini liquid, and rosemary; heat to boiling. Reduce heat and simmer, covered, until mushrooms are tender, about 15 minutes, adding lemon pulp and parsley during last 5 minutes. Season to taste with salt and pepper. Place Bruschetta in bottoms of soup bowls; ladle soup over.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 90</span></p>
<p class="per1"><span>% calories from fat: 10</span></p>
<p class="per1"><span>Protein (g): 3.7</span></p>
<p class="per1"><span>Carbohydrate (g): 14.9</span></p>
<p class="per1"><span>Fat (g): 1</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 86</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0228.vue?1532fb9a